import(/* webpackMode: "eager", webpackExports: ["AiToolsSection"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/AiToolsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnnouncementMarquee"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/AnnouncementMarquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DailyNewsMiniSection"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/DailyNewsMiniSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardHeader"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/DashboardHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FallbackBanner"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/FallbackBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeRecipesSection"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/HomeRecipesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LifecycleTabs"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/LifecycleTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyStoreGroupSection"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/MyStoreGroupSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreSetupBanner"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/StoreSetupBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValuePropHero"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/ValuePropHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WelcomeModal"] */ "/opt/trendrain/trendrain-web/src/components/dashboard/WelcomeModal.tsx");
